module.exports = __webpack_public_path__ + "static/media/hotmesslogo.95d767e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/hotmesslogo.png
// module id = 11
// module chunks = 0